import { Box, Typography } from "@mui/material";
import NetworkIssueImage from "../../assets/images/NetworkIssue.png";
import { colors } from "../../theme/palette";

const NetworkError = () => {
  return (
    <Box sx={{ width: "100%", minWidth: "870px" }}>
      <Box
        sx={{
          maxWidth: " 312px !important",
          margin: "0 auto",
          width: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "90vh",
        }}
      >
        <img
          src={NetworkIssueImage}
          alt="Network issue image"
          style={{
            width: "248.963px",
            height: "186.722px",
          }}
        />
        <Typography
          variant="h2"
          sx={{
            color: "var(--Green---100, #106048)",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "normal",
          }}
        >
          You’ve Lost the Ball!
        </Typography>
        <Typography
          component="p"
          sx={{
            color: "var(--Dark---600, #707070)",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "150%",
          }}
        >
          Looks like you’ve temporarily lost your connection. Don’t worry, just like in football, you can’t always have
          possession. Check your network connection and try again.
        </Typography>
      </Box>
    </Box>
  );
};

export default NetworkError;
